// extracted by mini-css-extract-plugin
export default {"richEditorHeight":"richTextEditorStyle_richEditorHeight__cuEoP","richEditorReplyHeight":"richTextEditorStyle_richEditorReplyHeight__3KHZc"};